export const hideError = (form: Element, clearErrors: (args: unknown[]) => void) => {
  if (!form) return;
  clearErrors([]);
  const errorBlock = form.querySelector('ul.Help-block_list');
  errorBlock && errorBlock.remove();
};

export const removeErrors = (form: Element) => {
  if (!form) return;
  const errorBlock = form.querySelector('ul.Help-block_list');
  errorBlock && errorBlock.remove();
};

export const showError = (
  form: Element,
  errors: Record<string, string>,
  clearErrors: (args: unknown[]) => void,
  hideAfter = 0,
) => {
  if (!form) return;
  let errorTag = form.querySelector('ul.Help-block_list');
  if (!errorTag) errorTag = document.createElement('ul');
  errorTag.classList.add('Help-block_list');
  const closeBtn = document.createElement('a');
  closeBtn.setAttribute('id', 'close');
  closeBtn.setAttribute('href', '#');
  closeBtn.addEventListener('click', () => clearErrors([]));
  errorTag.appendChild(closeBtn);
  Object.keys(errors).map((key: string) => {
    const listItem = document.createElement('li');
    listItem.setAttribute('key', key);
    listItem.innerHTML = errors[key];
    errorTag?.appendChild(listItem);
    return errorTag;
  });
  form.insertBefore(errorTag, form.firstElementChild);
  hideAfter && setTimeout(() => hideError(form, clearErrors), hideAfter);
};
